class PathDB {

    constructor() {
        this.db = {};
    }

    static fromOB(ob) {
        let pathDb = new PathDB();
        pathDb.db = JSON.parse(JSON.stringify(ob));
        return pathDb;
    }

    setToPath(path, value, db = undefined) {
        if (db === undefined) {
            db = this.db;
        }
        let split = path.split('/');
        let key = split.shift();
        if (!key) {
            return;
        }
        let isLast = split.length === 0;
        let isArray = key.endsWith('[]');
        key = key.replaceAll('[]', "");
        if (db.hasOwnProperty(key) === false) {
            if (isArray) {
                db[key] = [];
            } else {
                db[key] = {};
            }
        }
        if (isLast) {
            if (isArray) {
                if (db[key].indexOf(value) === -1) {
                    db[key].push(value);
                }
            } else {
                db[key] = value;
            }
        } else {
            this.setToPath(split.join('/'), value, db[key]);
        }
    }


    getValue(path, db) {
        if (db === undefined) {
            db = this.db;
        }
        let split = path.split('/');
        let key = split.shift();

        let isLast = split.length === 0;
        if (isLast) {
            return db[key];
        } else if (db.hasOwnProperty(key)) {
            return this.getValue(split.join('/'), db[key]);
        } else {
            return undefined;
        }

    }

    deletePath(path, db) {
        if (db === undefined) {
            db = this.db;
        }
        let split = path.split('/');
        let key = split.shift();

        let isLast = split.length === 0;
        if (isLast) {
            delete db[key];
        } else if (db.hasOwnProperty(key)) {
            return this.deletePath(split.join('/'), db[key]);
        } else {
            return;
        }
    }


}




class UserHomeRepresentation {

    constructor(homeId) {
        this.db = new PathDB();
        this.homeId = homeId;
    }

    static cast(variable) {
        if (variable instanceof UserHomeRepresentation) {
            return variable;
        }
        return;
    }

    static fromJSON({ homeId, db }) {
        let ob = new UserHomeRepresentation(homeId)
        ob.db = PathDB.fromOB(db);
        return ob;
    }


    injectEnrolledThing(enrolledThing) {
        if (this.homeId === enrolledThing.home) {
            let type = enrolledThing.type;
            let id = enrolledThing._id;
            this.db.setToPath(`enrolledThing/${id}`, enrolledThing);
            this.db.setToPath(`${type}[]`, enrolledThing._id);
        }
    }


    injectOutput(output) {
        let outputId = output._id;
        let enrolledThing = this.db.getValue(`enrolledThing/${output.enrolledThing}`);
        if (enrolledThing) {
            let type = output.type;
            this.db.setToPath(`outputs/${outputId}`, { ...output });
            this.db.setToPath(`outputTypes/${type}/enrolledThing`, enrolledThing._id);
            this.db.setToPath(`outputTypes/${type}/output`, outputId);
        }
    }

    injectInput(input) {
        let inputId = input._id;
        let enrolledThing = this.db.getValue(`enrolledThing/${input.enrolledThing}`);
        if (enrolledThing) {
            this.db.setToPath(`inputs/${inputId}/enrolledThing`, enrolledThing._id);
            this.db.setToPath(`inputs/${inputId}/relay`, input.type);
        }
    }

    injectEdge(edge) {
        let edgeId = edge._id;
        let input = edge.input;
        let output = edge.output;
        let inputOb = this.db.getValue(`inputs/${input}`);
        let outputOb = this.db.getValue(`outputs/${output}`);
        if (inputOb && outputOb) {
            this.db.setToPath(`edge/${edgeId}`, {
                edgeId: edgeId,
                input,
                output,
            });
        }
    }

    ejectEdge(edgeId) {
        this.db.deletePath(`edge/${edgeId}`);
    }

    toJSON() {
        return { ...this.db.db };
    }





}



export { UserHomeRepresentation };